// Converts the first letter of each word to capital except some backlisted words
// Eg: "john doe vs jane doe" => "John Doe vs Jane Doe"
export const titleCapitalize = (string) => {
    const exceptions = ["vs", "versus", "v/s", "vs."];
    const caps = string.split(' ').map((word)=>capitalize(word, exceptions)).join(' ');
    return caps;
}

// Helper functions
const capitalize = (word, exceptions) => {
    if(exceptions.includes(word.toLowerCase())){
        return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}